import QueryController from '@mulesoft/ang-search-component/lib/search/QueryController';
import { QueryExecutor } from '@mulesoft/ang-search-component/lib/search/QueryExecutor';
import * as constants from '~/utils/ang/constants';

const queryExecutor = new QueryExecutor();

export default class ANGFactory {
  static createQueryExecutor = () => queryExecutor;

  static createQueryController = ({ config, authorization, state }) =>
    new QueryController({
      config,
      headers: authorization
        ? {
            Authorization: authorization
          }
        : {},
      states: state,
      streamed: config[constants.STREAMED_KEY] || false
    });
}
